(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3904],{

/***/ 11501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SafeSuspenseLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_SafeSuspense__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5822);
/* harmony import */ var _SuspenseLoading_Loading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53762);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function SafeSuspenseLoading(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SafeSuspense__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SuspenseLoading_Loading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread({}, props)),
        children: props.children
    });
};


/***/ }),

/***/ 53762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8165);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function Loading(props) {
    var height = props.height || 200;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
        style: {
            height: height
        }
    });
};


/***/ }),

/***/ 68400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useIsStore; }
});

;// CONCATENATED MODULE: ./src/helpers/websites/isStore.ts
function isStore(businessType) {
    return businessType === "store";
};

// EXTERNAL MODULE: ./src/page-components/Layout/useInitialData.ts
var useInitialData = __webpack_require__(62832);
;// CONCATENATED MODULE: ./src/hooks/useWebsiteBusinessType.ts

function useWebsiteBusinessType() {
    var website = (0,useInitialData/* default */.Z)().website;
    return website.businessType;
};

;// CONCATENATED MODULE: ./src/hooks/useIsStore.ts


function useIsStore(website) {
    var businessType = useWebsiteBusinessType();
    if (website === null || website === void 0 ? void 0 : website.businessType) {
        businessType = website.businessType;
    }
    return isStore(businessType);
};


/***/ }),

/***/ 73904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ DefaultLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_SafeSuspenseLoading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11501);
/* harmony import */ var _helpers_misc_isIFrame__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29453);
/* harmony import */ var _hooks_useIsSpecialLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5455);
/* harmony import */ var _hooks_useIsStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68400);
/* harmony import */ var _hooks_useWebsiteLayout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18368);
/* harmony import */ var _page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62832);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_7__);









var NavbarCPG = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(5445), __webpack_require__.e(9866), __webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(191), __webpack_require__.e(5837), __webpack_require__.e(7502), __webpack_require__.e(791), __webpack_require__.e(6665), __webpack_require__.e(4761), __webpack_require__.e(1047), __webpack_require__.e(8799), __webpack_require__.e(351), __webpack_require__.e(1620), __webpack_require__.e(2554), __webpack_require__.e(4948), __webpack_require__.e(8102), __webpack_require__.e(3063), __webpack_require__.e(1094), __webpack_require__.e(8912)]).then(__webpack_require__.bind(__webpack_require__, 43449));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43449)
            ];
        }
    }
});
var NavbarRestaurant = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6907), __webpack_require__.e(791), __webpack_require__.e(351), __webpack_require__.e(1094), __webpack_require__.e(2720)]).then(__webpack_require__.bind(__webpack_require__, 63359));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63359)
            ];
        }
    }
});
function DefaultLayout(props) {
    var website = (0,_page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().website;
    var layout = (0,_hooks_useWebsiteLayout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(website);
    var isStore = (0,_hooks_useIsStore__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(website);
    var specialLayout = (0,_hooks_useIsSpecialLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var Navbar = isStore && layout.headerLayout === "cpg" ? NavbarCPG : NavbarRestaurant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            _helpers_misc_isIFrame__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z || specialLayout === "chat" ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SafeSuspenseLoading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Navbar, {})
            }),
            props.children
        ]
    });
};


/***/ }),

/***/ 8165:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3dzszu0edT56nvw27R-vYR loadingGlow"};

/***/ })

}]);